
import { throttle } from "throttle-debounce";
import { defineComponent, onMounted, Ref, ref } from "vue";
import VueChatScrollDirective from "vue-chat-scroll/src/directives/v-chat-scroll";

export default defineComponent({
  name: "Scrollable",
  directives: {
    "chat-scroll": {
      bind: (el, binding) => {
        if (binding.value) VueChatScrollDirective.bind(el, binding);
      },
      inserted: (el, binding) => {
        if (binding.value) VueChatScrollDirective.inserted(el, binding);
      },
    },
  },
  props: {
    withoutScrollbar: {
      type: Boolean,
      default: false,
    },
    withShadows: {
      type: Boolean,
      default: true,
    },
    withChatScroll: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { expose }) {
    const container: Ref<Nullable<HTMLElement>> = ref(null);
    const state = ref({
      top: false,
      bottom: false,
    });

    const handleScroll = (event: Event) => {
      const target = event.target as HTMLDivElement;

      checkDimensions(target);
    };

    const checkDimensions = (element: HTMLElement | undefined) => {
      if (element) {
        state.value.top = element.scrollTop > 20;
        state.value.bottom =
          element.scrollHeight > element.clientHeight &&
          element.scrollTop < element.scrollHeight - element.clientHeight - 20;
      }
    };

    const handleScrollThrottled = throttle(50, (event) => {
      handleScroll(event);
    });

    const classes = {
      "without-scrollbar": props.withoutScrollbar,
      "with-shadows": props.withShadows,
    };

    onMounted(() => {
      setTimeout(() => checkDimensions(container.value!), 100);
    });

    const directiveOptions = props.withChatScroll ? { always: false, smooth: true, notSmoothOnInit: true } : false;

    expose({ checkDimensions });

    return { container, state, handleScroll, handleScrollThrottled, classes, directiveOptions, checkDimensions };
  },
});
